// extracted by mini-css-extract-plugin
export default {"productGallery":"_F-z","inQuickShop":"aG-z"};